import React from 'react';
import { Grid, TextField, Typography, Box, FormControl, InputLabel, Select, MenuItem, ListSubheader } from '@mui/material';
import { doctorGroups } from '../constants/options';

const DemographicsSection = ({ formData, handleChange, errors }) => {
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="IP No."
            name="ip_no"
            value={formData.ip_no || ''}
            InputProps={{ readOnly: true }}
            variant="outlined"
            helperText="Auto-generated IP number"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="UHID No."
            name="uhid_no"
            value={formData.uhid_no || ''}
            InputProps={{ readOnly: true }}
            variant="outlined"
            helperText="Patient UHID from records"
          />
        </Grid>
      </Grid>

      <Box sx={{ mt: 3, mb: 2 }}>
        <Typography variant="body1" sx={{ lineHeight: 1.6 }}>
          I have been explained about the following medical condition and the proposed surgery / procedure by
        </Typography>
        <FormControl fullWidth sx={{ mt: 1 }} error={!!errors.procedure_by_dr}>
          <InputLabel>Doctor's Name *</InputLabel>
          <Select
            name="procedure_by_dr"
            value={formData.procedure_by_dr || ''}
            label="Doctor's Name *"
            onChange={handleChange}
          >
            <MenuItem value=""><em>Select Doctor</em></MenuItem>
            {Object.entries(doctorGroups).map(([specialty, doctors]) => [
              <ListSubheader key={specialty}>{specialty}</ListSubheader>,
              doctors.map((doctor, idx) => (
                <MenuItem key={`${specialty}-${idx}`} value={doctor}>{doctor}</MenuItem>
              )),
            ])}
          </Select>
          {errors.procedure_by_dr && (
            <Typography variant="caption" color="error" sx={{ ml: 1.5 }}>
              {errors.procedure_by_dr}
            </Typography>
          )}
        </FormControl>
      </Box>
    </Box>
  );
};

export default DemographicsSection;
